/**
 * @license lucide-react v0.503.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createLucideIcon from '../createLucideIcon.js';

const __iconNode = [
  ["path", { d: "M15 5H9", key: "1tp3ed" }],
  ["path", { d: "M15 9v3h4l-7 7-7-7h4V9z", key: "ncdc4b" }]
];
const ArrowBigDownDash = createLucideIcon("arrow-big-down-dash", __iconNode);

export { __iconNode, ArrowBigDownDash as default };
//# sourceMappingURL=arrow-big-down-dash.js.map
